import React from 'react';
import { Link } from 'react-router-dom';

const footerLinks = [
  { to: '/privacy/policy', label: 'Privacy Policy' },
  { to: '/terms/use', label: 'Terms of Use' },
  { to: '/faq', label: 'FAQ' },
  { to: '/help', label: 'Help Center' },
  { to: '/blog', label: 'Blog' },
  { to: '/contact/us', label: 'Contact Us' },
];

const PublicFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="tw-bg-gray-900 tw-text-gray-300">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        {/* Main Footer */}
        <div className="tw-py-12 md:tw-py-16">
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-8">
            {/* Brand */}
            <div>
              <img
                src={process.env.PUBLIC_URL + '/images/rmt-logo-white.png'}
                alt="RMT"
                className="tw-h-10 tw-mb-4"
              />
              <p className="tw-text-sm tw-text-gray-400 tw-leading-relaxed tw-max-w-sm">
                Automated vehicle tag renewal service. Never miss a renewal deadline again.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="tw-text-sm tw-font-semibold tw-text-white tw-uppercase tw-tracking-wider tw-mb-4">
                Quick Links
              </h4>
              <ul className="tw-list-none tw-p-0 tw-m-0 tw-space-y-2">
                {footerLinks.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="tw-text-sm tw-text-gray-400 hover:tw-text-white tw-transition-colors tw-duration-200 tw-no-underline"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="tw-text-sm tw-font-semibold tw-text-white tw-uppercase tw-tracking-wider tw-mb-4">
                Get in Touch
              </h4>
              <ul className="tw-list-none tw-p-0 tw-m-0 tw-space-y-2">
                <li>
                  <a
                    href="mailto:support@renewmytags.com"
                    className="tw-text-sm tw-text-gray-400 hover:tw-text-white tw-transition-colors tw-duration-200 tw-no-underline"
                  >
                    support@renewmytags.com
                  </a>
                </li>
                <li>
                  <Link
                    to="/contact/us"
                    className="tw-text-sm tw-text-gray-400 hover:tw-text-white tw-transition-colors tw-duration-200 tw-no-underline"
                  >
                    Contact Form
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Government Disclaimer */}
        <div className="tw-border-t tw-border-gray-800 tw-py-4">
          <p className="tw-text-xs tw-text-gray-500 tw-m-0 tw-leading-relaxed tw-text-center">
            RMT (Renew My Technologies) is a private company that provides vehicle registration renewal services. We are not a government agency, nor are we affiliated with or endorsed by any federal, state, or local government entity. We work with government offices on your behalf to process renewals.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="tw-border-t tw-border-gray-800 tw-py-6 tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-between tw-gap-4">
          <p className="tw-text-xs tw-text-gray-500 tw-m-0">
            &copy; {currentYear} RMT. All rights reserved.
          </p>
          <div className="tw-flex tw-items-center tw-gap-2">
            <svg className="tw-w-4 tw-h-4 tw-text-accent-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
            </svg>
            <span className="tw-text-xs tw-text-gray-500">Secure & encrypted</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
